import { Client } from '@microsoft/microsoft-graph-client';

let graphClient;

function ensureClient(authProvider) {
    if (!graphClient) {
        graphClient = Client.initWithMiddleware({
            authProvider: {
                getAccessToken: async () => await authProvider.getAccessToken()
            }
        });
    }

    return graphClient;
}

export async function getUser(authProvider) {
    ensureClient(authProvider);

    const user = await graphClient.api('/me')
        .select('id,displayName,givenName,surname,userPrincipalName,mail,jobTitle,department,mobilePhone,businessPhones,officeLocation,preferredLanguage')
        .get();

    return user;
}